module.exports = require("@fortawesome/free-solid-svg-icons/faChevronRight");